import { printHtmlNodesToText, printHtmlNodesToJsx, generateJsxKey } from '@utils/ast';
import { FlashcardRouter } from './comp.router.js';
import { jsx } from 'react/jsx-runtime';

const printFlashcardComponent = (node, context) => {
  return /*#__PURE__*/jsx(FlashcardRouter, {
    component: node.component,
    richtextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    lightboxDescription: printHtmlNodesToText(node.meta.lightboxDescription ?? []),
    previewImage: node.meta.previewImage,
    indexOrLevel: node.meta.indexOrLevel,
    displayMode: node.options.displayMode,
    isScrambled: node.pm2.isScrambled,
    node: node,
    onResetEntry: undefined
  }, generateJsxKey(context));
};
const flashcardComponentJsxPrinters = {
  "component-framework.flashcard": printFlashcardComponent
};

export { flashcardComponentJsxPrinters, printFlashcardComponent };
//# sourceMappingURL=printer.to-jsx.js.map
